import { lazy } from "react";

const routes = [
  {
    path: "/country",
    element: lazy(() => import("../pages/Country")),
  },
  {
    path: "/country/add",
    element: lazy(() => import("../pages/Country/CountryForm")),
  },
  {
    path: "/country/edit/:id",
    element: lazy(() => import("../pages/Country/CountryForm")),
  },
];

export default routes;
